import { GridValidRowModel } from '@mui/x-data-grid-pro';

interface ImageCellProps<R extends GridValidRowModel = any> {
  row: R;
  src?: string;
  alt?: string;
}

export const ImageCell = <R extends GridValidRowModel = any>({ src, alt }: ImageCellProps<R>) => {
  if (!src) {
    return null;
  }
  return <img src={src} alt={alt} style={{ objectFit: 'contain', width: '100%', height: '100%' }} />;
};
